import React, { Component } from 'react'
import { connect } from 'react-redux'
import {getCreditLimitModelList} from './action'
import {Col, Row, Button,Card, CardBody} from 'reactstrap';
import Table from "../../../components/UI/Table/Table";
import { Link } from "react-router-dom";
// import { Col, Row, Card, CardBody, Button } from 'reactstrap';
// import { Field, reduxForm, FieldArray } from 'redux-form'
// import { required } from 'glamor';

class ViewAllCreditLimitComponent extends Component {
     constructor(props) {
         super(props);
         this.state = {
          allModelList:[]
         };
     }  

    componentDidMount() {
        this.props.getCreditLimitModelList();
    }

    componentDidUpdate(prevProps) {
        if (this.props.creditLimitModelList !== prevProps.creditLimitModelList) {
            this.setState({
                allModelList:this.props.creditLimitModelList
            })
        }
    }

    render() {
      return(
        <Col>
        <div className="d-flex justify-content-between align-items-center mb-3">
           <h4 className="mb-0">View All Credit Limit Models</h4>
        </div>
        <Card>
           <CardBody>
           <Table
                data={Array.isArray(this.state.allModelList) ? this.state.allModelList : []}
                noDataText="No user exists with assigned role as analyst "
                columns={
                        [
                            {
                                Header: "Model Name",
                                id: "name",
                                accessor: "name",
                                className: 'center',
                            },
                            {
                                Header: "Action",
                                id: "Edit",
                                accessor: p => <Link tag="button" id={p.id} to={{ pathname: `./../list/edit/${p.id}`, state: p }}><i className="icon-edit border border-primary radius-4 p-2 font-size-16" color="primary" /></Link>,
                                className: 'center'
                            }
                        ]
                        }
                        defaultPageSize={10}
                        />
           </CardBody>
        </Card>
     </Col>    
        );  
    }
}

const mapStateToProps = (state, ownProps) => ({
    creditLimitModelList: state.creditLimitModelList.creditLimitModelListSuccess
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    getCreditLimitModelList: () => dispatch(getCreditLimitModelList()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewAllCreditLimitComponent);
